"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConstantsInfoEmp = exports.getHeaderInfoEmp = exports.getHeaderInfo = exports.getFooterInfoEmp = exports.getFooterInfo = exports.errorDetected = void 0;
const bit_utils_types_1 = require("@gcloud-npm/bit.utils.types");
const bit_utils_request_1 = __importStar(require("@gcloud-npm/bit.utils.request"));
const bit_utils_front_sonda_1 = __importDefault(require("@gcloud-npm/bit.utils.front-sonda"));
var PATHS;
(function (PATHS) {
    PATHS["GET_FOOTER_INFO"] = "/static/json/footer/footer.json";
    PATHS["GET_FOOTER_INFO_EMP"] = "/static/json/footer/footerEmp.json";
    PATHS["GET_HEADER_INFO"] = "/static/json/header/header.json";
    PATHS["GET_HEADER_INFO_EMP"] = "/static/json/header/headerEmp.json";
    PATHS["GET_CONSTANTS_INFO_EMP"] = "/static/json/constants/constantsEmp.json";
})(PATHS || (PATHS = {}));
var errorDetected = function (sonda) {
    sonda.errorMessage({
        info: "Ha fallado la petici\u00F3n al json: ".concat(sonda.processName),
    });
    return null;
};
exports.errorDetected = errorDetected;
var getFooterInfo = function (context) {
    var myFrontSonda = new bit_utils_front_sonda_1.default({
        processName: 'MISCELLANEOUS.GET_FOOTER_INFO',
        context: context,
        filePath: 'sagas/footer',
    });
    var connectionData = context.environment.bucket;
    var host = connectionData.endpoint, headers = connectionData.headers;
    var envName = context.environment.name;
    var URL_API = "".concat(host).concat(PATHS.GET_FOOTER_INFO);
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)('getFooterInfo', envName);
    try {
        var request = new bit_utils_request_1.default({
            method: bit_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onError: function () { return (0, exports.errorDetected)(myFrontSonda); },
            headers: headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        myFrontSonda.errorMessage({
            error: err,
            info: 'Ha fallado js durante la invocación al json',
        });
        return null;
    }
};
exports.getFooterInfo = getFooterInfo;
var getFooterInfoEmp = function (context) {
    var myFrontSonda = new bit_utils_front_sonda_1.default({
        processName: 'MISCELLANEOUS.GET_FOOTER_INFO_EMP',
        context: context,
        filePath: 'sagas/footer',
    });
    var connectionData = context.environment.bucket;
    var host = connectionData.endpoint, headers = connectionData.headers;
    var envName = context.environment.name;
    var URL_API = "".concat(host).concat(PATHS.GET_FOOTER_INFO_EMP);
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)('getFooterInfoEmp', envName);
    try {
        var request = new bit_utils_request_1.default({
            method: bit_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onError: function () { return (0, exports.errorDetected)(myFrontSonda); },
            headers: headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        myFrontSonda.errorMessage({
            error: err,
            info: 'Ha fallado js durante la invocación al json',
        });
        return null;
    }
};
exports.getFooterInfoEmp = getFooterInfoEmp;
var getHeaderInfo = function (context) {
    var myFrontSonda = new bit_utils_front_sonda_1.default({
        processName: 'MISCELLANEOUS.GET_HEADER_INFO',
        context: context,
        filePath: 'sagas/header',
    });
    var connectionData = context.environment.bucket;
    var host = connectionData.endpoint, headers = connectionData.headers;
    var envName = context.environment.name;
    var URL_API = "".concat(host).concat(PATHS.GET_HEADER_INFO);
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)('getHeaderInfo', envName);
    try {
        var request = new bit_utils_request_1.default({
            method: bit_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onError: function () { return (0, exports.errorDetected)(myFrontSonda); },
            headers: headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        myFrontSonda.errorMessage({
            error: err,
            info: 'Ha fallado js durante la invocación al json',
        });
        return null;
    }
};
exports.getHeaderInfo = getHeaderInfo;
var getHeaderInfoEmp = function (context) {
    var myFrontSonda = new bit_utils_front_sonda_1.default({
        processName: 'MISCELLANEOUS.GET_HEADER_INFO_EMP',
        context: context,
        filePath: 'sagas/header',
    });
    var connectionData = context.environment.bucket;
    var host = connectionData.endpoint, headers = connectionData.headers;
    var envName = context.environment.name;
    var URL_API = "".concat(host).concat(PATHS.GET_HEADER_INFO_EMP);
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)('getHeaderInfoEmp', envName);
    try {
        var request = new bit_utils_request_1.default({
            method: bit_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onError: function () { return (0, exports.errorDetected)(myFrontSonda); },
            headers: headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        myFrontSonda.errorMessage({
            error: err,
            info: 'Ha fallado js durante la invocación al json',
        });
        return null;
    }
};
exports.getHeaderInfoEmp = getHeaderInfoEmp;
var getConstantsInfoEmp = function (context) {
    var myFrontSonda = new bit_utils_front_sonda_1.default({
        processName: 'MISCELLANEOUS.GET_CONSTANTS_INFO_EMP',
        context: context,
        filePath: 'sagas/header',
    });
    var connectionData = context.environment.bucket;
    var host = connectionData.endpoint, headers = connectionData.headers;
    var envName = context.environment.name;
    var URL_API = "".concat(host).concat(PATHS.GET_CONSTANTS_INFO_EMP);
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)('getConstantsInfoEmp', envName);
    try {
        var request = new bit_utils_request_1.default({
            method: bit_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onError: function () { return (0, exports.errorDetected)(myFrontSonda); },
            headers: headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        myFrontSonda.errorMessage({
            error: err,
            info: 'Ha fallado js durante la invocación al json',
        });
        return null;
    }
};
exports.getConstantsInfoEmp = getConstantsInfoEmp;
//# sourceMappingURL=index.js.map